import { api } from "./api";
import type {
  FarmListItem,
  CreateFarmResponse,
  User,
  ResetPINResponse,
} from "@/types/models";

export const systemAdminService = {
  listFarms: () =>
    api.get<FarmListItem[]>("/system/farms").then((r) => r.data),

  createFarm: (data: {
    farm_name: string;
    owner_name: string;
    owner_phone: string;
    owner_email?: string;
  }) =>
    api
      .post<CreateFarmResponse>("/system/farms", data)
      .then((r) => r.data),

  listFarmUsers: (farmId: number) =>
    api.get<User[]>(`/system/farms/${farmId}/users`).then((r) => r.data),

  updateUser: (
    userId: number,
    data: {
      name: string;
      phone: string;
      role: string;
      active: boolean;
      email?: string;
    }
  ) =>
    api.put<User>(`/system/users/${userId}`, data).then((r) => r.data),

  resetUserPIN: (userId: number) =>
    api
      .post<ResetPINResponse>(`/system/users/${userId}/reset-pin`)
      .then((r) => r.data),

  sendPINEmail: (data: {
    email: string;
    user_name: string;
    phone: string;
    farm_name: string;
    pin: string;
  }) => api.post("/system/send-pin-email", data).then((r) => r.data),
};
